import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import './styles/CustomModal.scss';

const CustomModal = ({
  show,
  onHide,
  title,
  body,
  confirmText,
  cancelText = '取消',
  onConfirm,
  confirmBtnDisabled,
  size,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered={true}
      animation={true}
      backdrop="static"
      size={size}
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ display: 'flex', justifyContent: 'center' }}>
        {body}
      </Modal.Body>
      <Modal.Footer>
        {confirmText && (
          <Button
            variant="primary"
            onClick={onConfirm}
            disabled={confirmBtnDisabled}
          >
            {confirmText}
          </Button>
        )}
        <Button variant="secondary" onClick={onHide}>
          {cancelText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CustomModal;
